import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { AccordionComponent } from '../../accordion/accordion.component';
import { ExpansionDirective } from '../../accordion/expansion.directive';

@Component({
  selector: 'app-product-safety-description',
  imports: [TranslocoDirective, AccordionComponent, ExpansionDirective],
  templateUrl: './product-safety-description.component.html',
  styleUrl: './product-safety-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductSafetyDescriptionComponent {
  @Input({ required: true })
  productType = '';
}
